type ArrowScrollSvgProps = {
    direction: 'left' | 'right';
    onClick: () => void;
};

const ArrowScrollSvg = ({ direction, onClick }: ArrowScrollSvgProps) => {
    const classNameValue =
        'w-[4vw] h-[4vw] p-[0.9vw] object-contain cursor-pointer transition-opacity duration-200 flex items-center justify-center';
    const upperCaseDirection = direction[0].toUpperCase() + direction.slice(1);
    return (
        <button
            onClick={onClick}
            className={`${classNameValue} hover:opacity-70 focus:outline-none`}
        >
            <img
                className="w-full h-full"
                src={`https://pizzahut-assets.s3.amazonaws.com/icons/assets/${upperCaseDirection}ArrowScrollSvg.svg`}
                alt={`Scroll ${direction}`}
            />
        </button>
    );
};

export default ArrowScrollSvg;
